<template>
  <breeze-authenticated-layout>
    <div class="row">
      <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Dashboard'">
      <div class="col-12">
        <span>coming soon</span>
      </div>
    </div>
    <div
      class="row p-3"
      v-if="currentTab === 'Heartrate' && isFeatureAllowed('dashboard_sims')"
    >
      <heartrate-sim />
    </div>
    <div
      class="row p-3"
      v-if="currentTab === 'Scale' && isFeatureAllowed('dashboard_sims')"
    >
      <scale-sim />
    </div>
  </breeze-authenticated-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import ZTabs from '@/Components/ZElements/Tabs'
import HeartrateSim from '@/Components/UserCardio/client/assessment/vo2/heartrate-sim'
import ScaleSim from '@/Components/UserCardio/client/assessment/scale/scale-sim'
// import ReportingDashboard from '@/Components/Reporting/dashboard'
export default {
  components: {
    BreezeAuthenticatedLayout,
    // ReportingDashboard,
    ZTabs,
    HeartrateSim,
    ScaleSim,
  },
  data() {
    return {
      currentTab: 'Dashboard',
    }
  },
  computed: {
    ...mapGetters('users', ['isFeatureAllowed']),
    tabs() {
      let _tabs = ['Dashboard']
      if (this.isFeatureAllowed('dashboard_sims')) {
        _tabs = ['Dashboard', 'Heartrate', 'Scale']
      }
      return _tabs
    },
  },
  methods: {
    showTab(value) {
      this.currentTab = value
    },
  },
}
</script>
